export default __webpack_public_path__ + "static/media/Icon_Class_Doctor.af32ac42.png";